// DS: i4.6
import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import IconWrap from '../../IconWrap';
const Popular = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, _extends({}, props), /*#__PURE__*/ React.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M14.038 3.801l.564 2.318a1 1 0 00.255.461l4.86 4.994a1 1 0 01.283.697v6.163a1 1 0 01-.486.857l-2.878 1.728L15 21v-2.623a1 1 0 00-.248-.66l-1.36-1.55a1 1 0 01-.25-.66v-.78a.457.457 0 00-.79-.312L9.27 17.712a1 1 0 00-.27.683V21l-1.98-.048-2.488-1.315A1 1 0 014 18.753v-4.81a1 1 0 01.244-.655l1.641-1.897a1 1 0 011.41-.102 1 1 0 01.056.051L9 13l.027-5.708a1 1 0 01.269-.678l3.04-3.258a1 1 0 011.702.445z",
        fillRule: "evenodd"
    })));
};
Popular.displayName = 'Popular';
export default Popular;
